<script>
export default {
    props: {
        addresses: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            addressList: this.addresses
        }
    },

    created() {
        this.$bus.$on('address-added', address => this.add(address))
        this.$bus.$on('address-deleted', address => this.remove(address))
    },

    methods: {
        add(address) {
            this.addressList.splice(0, 0, address)
        },

        remove(address) {
            this.addressList.splice(this.addressList.indexOf(address), 1)
        }
    },

    render() {
        return this.$scopedSlots.default({
            addressList: this.addressList
        })
    }
}
</script>

<style scoped>
    .list-complete-item {
      transition: all 1s;
      display: inline-block;
      margin-right: 10px;
    }

    /* .list-complete-leave-active below version 2.1.8 */
    .list-complete-enter,
    .list-complete-leave-to {
      opacity: 0;
      transform: translateY(30px);
    }

    .list-complete-leave-active {
      position: absolute;
    }
</style>
